import styled, { css } from 'styled-components'
import { above } from '@styles/mixins/breakpoints'
import Cross from '@icons/close.inline.svg'
import { colors } from '@styles/theme'
import { SH3, STypographyParagraph } from '@components/Typography'
import { SWideButton } from '@components/Benefits/Card'
import Input, { withInput } from '@components/Input/Input'
import { ISButtonProps } from '@components/LeavePopup/types'

export const SCloseButton = styled.button`
  background-color: transparent;
  border: none;
  padding: 0;
  display: none;
  position: absolute;
  top: 18px;
  right: 18px;
  width: 24px;
  height: 24px;
  justify-content: center;
  align-items: center;
  opacity: 0.4;

  &:hover {
    cursor: pointer;
    opacity: 1;
  }

  ${above('md')(css`
    display: flex;
  `)}
`

export const SCloseIcon = styled(Cross)`
  width: 12px;
  height: 12px;

  path {
    fill: #333;
  }
`

export const SOverlay = styled.div`
  height: 100%;
  overflow-y: auto;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 20px 0;

  ${above('md')(css`
    padding: 105px 125px 0;
  `)}
`

export const SContainer = styled.div`
  position: relative;
  background-color: ${colors.white};
  max-height: 850px;
  width: 100%;
  border: 1px solid ${colors.lightGray};
  box-sizing: border-box;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;

  ${above('md')(css`
    max-width: 640px;
    padding: 40px;
    margin-bottom: 50px;
  `)}

  ${above('xl')(css`
    max-width: 522px;
  `)}
`

export const STitle = styled(SH3)`
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 12px;

  ${above('md')(css`
    font-size: 24px;
    line-height: 28px;
    max-width: 300px;
    margin-bottom: 24px;
  `)}
`

export const SForm = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-bottom: 12px;

  ${above('md')(css`
    margin-bottom: 24px;
  `)}
`

export const SInputLabel = styled.label`
  display: flex;
  flex-direction: column;
`

export const STextAreaLabel = styled(SInputLabel)`
  height: 100%;
`

export const SLabelText = styled(STypographyParagraph)`
  font-size: 12px;
  line-height: 16px;
  margin-bottom: 4px;
`

export const SButtonContainer = styled.div`
  ${above('xl')(css`
    display: flex;
    margin-top: 12px;
  `)}
`

export const SSubmitButton = styled(SWideButton)<{ type: string }>`
  margin-top: 32px;
  margin-bottom: 12px;
  margin-right: 12px;
  padding-bottom: 14px;
  height: 52px;
  ${({ disabled }) => (disabled ? `background: ${colors.middleGray};` : '')}
  ${({ disabled }) => (disabled ? 'border: none ;' : '')}

  &:hover {
    ${({ disabled }) => `background-color: ${disabled ? colors.middleGray : colors.darkBlue};`}
    ${({ disabled }) => `border-color: ${disabled ? colors.middleGray : colors.darkBlue};`}
    ${({ disabled }) => `cursor: ${disabled ? 'unset' : 'pointer'};`}
  }

  ${above('xl')(css`
    margin-bottom: 0;
    margin-top: auto;
  `)}
`

export const SButton = styled(SWideButton)<ISButtonProps>`
  height: 52px;
  padding-bottom: 14px;
  background-color: ${({ theme, black }) => (black ? 'black' : theme.colors.white)};
  color: ${({ black }) => (black ? 'white' : 'black')};

  &:hover {
    background-color: ${colors.darkBlue};
    border-color: ${colors.darkBlue};
  }

  ${above('xl')(css`
    margin-bottom: 0;
    margin-top: auto;
  `)}
`

interface IWithError {
  error?: boolean
}

export const SInput = styled(Input)<IWithError>`
  ${({ error }) => (error ? `border-color: ${colors.red};` : '')}
`

export const STextArea = styled.textarea<IWithError>`
  height: 100%;
  max-height: 300px;
  width: 100%;
  resize: none;
  ${withInput}
  ${({ error }) => (error ? `border-color: ${colors.red};` : '')}

  ${above('md')(css`
    min-height: 100px;
  `)}
`

export const SCaptchaContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 24px;

  ${above('md')(css`
    flex-direction: row;
  `)}
`

export const SCaptchaImage = styled.img`
  width: 180px;
  height: 40px;
  margin-bottom: 20px;

  ${above('md')(css`
    margin-bottom: 0;
    margin-right: 18px;
  `)}
`

export const SFakeCaptchaImageBlock = styled.div`
  height: 40px;
  padding-left: 180px;
  margin-bottom: 20px;

  ${above('md')(css`
    margin-bottom: 0;
    margin-right: 18px;
  `)}
`

export const SImage = styled.img`
  margin-top: 174px;

  ${above('xl')(css`
    margin-top: 110px;
  `)}
`
